<template>
    <div class="block">
        <div class="loginlogo">
            <van-image width="50%" :src="VUE_APP_LOGIN_LOGO_URL" />
            <p style="font-size:18px;color: darkgray" @click="clearSession()">{{VUE_APP_LOGIN_LOGO_TITLE}}</p>
            <div class="loginbar">
                <van-form>
                    <van-field style="font-size: 16px;line-height: 32px"
                               v-model="appid"
                               name="appid"
                               left-icon="cluster-o"
                               label=" "
                               label-width="5px"
                               placeholder="请输入主账号"
                    />
                    <van-field style="font-size: 16px;line-height: 32px"
                               v-model="username"
                               name="username"
                               left-icon="user-o"
                               label=" "
                               label-width="5px"
                               placeholder="请输入用户名"
                    />
                    <van-field style="font-size: 16px;line-height: 32px"
                               v-model="password"
                               name="password"
                               type="password"
                               left-icon="edit"
                               label=" "
                               label-width="5px"
                               placeholder="请输入密码"
                    />
<!--                    <SliderVerificationCode style="width: 90%" height="30px" sliderBg="#6685a4" width="80%"-->
<!--                                            contentColor="#9ca0a7" background="#fff"-->
<!--                                            successBg="#6685a4" successContent="完成验证"-->
<!--                                            content="请拖动滑块"-->
<!--                                            v-model="value"/>-->


                    <!--                    <van-field style="font-size: 16px;line-height: 32px"-->
<!--                               v-model="smsCode"-->
<!--                               type="number"-->
<!--                               name="smsCode"-->
<!--                               left-icon="comment-o"-->
<!--                               label=" "-->
<!--                               label-width="5px"-->
<!--                               placeholder="请输入验证码"-->
<!--                    >-->
<!--                        <template #button>-->
<!--                            &lt;!&ndash;                            <van-button  size="normal" type="default" :disabled="buttonStatus" @click="sendMsg()">{{buttonTxt}}</van-button>&ndash;&gt;-->
<!--                            <a style="color: #6685a4;margin-right: 6px"  @click="sendMsg()">{{buttonTxt}}</a>-->
<!--                        </template>-->
<!--                    </van-field>-->
                    <div style="margin: 16px;">
                        <van-button color="#6685a4" block type="info" native-type="submit" style="font-size: 16px" @click="login()">
                            登录
                        </van-button>
                    </div>
                </van-form>
            </div>
            <!--<div class="userbiz">
                <span @click="register()">注册</span>
            </div>-->
            <!--            <div class="agreewarp">-->
            <!--                <van-checkbox  v-model="checked"  shape="square"  checked-color="#6685a4">登录表示同意<a @click.stop="showAgreement()">《用户协议》</a></van-checkbox>-->
            <!--            </div>-->

        </div>
        <!--        <div class="footer">-->
        <!--            Copyright©  2016-2020无锡云储科技有限公司<br/>-->
        <!--        </div>-->
        <van-overlay :show="show" @click="show">
            <div class="wrapper" @click.stop>
                <van-loading type="spinner" color="#1989fa" vertical><span style="color:#1989fa;font-weight: bolder">登录中..</span></van-loading>
            </div>
        </van-overlay>
    </div>
</template>

<script>
    // import Vue from 'vue'
    import {Image as VanImage, Toast} from 'vant';
    import { Form } from 'vant';
    import { Field,Checkbox  } from 'vant';
    import { Button } from 'vant';
    import service from '../server/index'
    import { Dialog } from 'vant';
    import { Overlay } from 'vant';
    import { Loading } from 'vant';
    // import SliderVerificationCode from 'slider-verification-code';
    // import 'slider-verification-code/lib/slider-verification-code.css';
    import qs from 'qs';
    // Vue.use(SliderVerificationCode);
    export default {
        name: "Login",
        components:{
            [VanImage.name]: VanImage,
            [Form.name]: Form,
            [Field.name]: Field,
            [Button.name]: Button,
            [Dialog.Component.name]: Dialog.Component,
            [Overlay.name]: Overlay,
            [Loading.name]: Loading,
            [Checkbox.name]:Checkbox

        },
        data() {
            return {
                appid:localStorage.getItem("appid")!=undefined?localStorage.getItem("appid"):"",
                username: '',
                password:'',
                smsCode: '',
                buttonTxt:"获取验证码",
                buttonStatus:false,
                smstime:0,
                timer:-1,
                show: false,
                clearSessionTime:0,
                value:true,
                VUE_APP_LOGIN_LOGO_URL:process.env.VUE_APP_LOGIN_LOGO_URL,
                VUE_APP_LOGIN_LOGO_TITLE:process.env.VUE_APP_LOGIN_LOGO_TITLE
                // checked:true
            };
        },
        created(){
            if(!this.getQueryString("code")&&!localStorage.getItem("code"))
            {
                let origin =  location.href;
                localStorage.setItem("url",process.env.VUE_APP_CUSTOMER_URL)
                let urlNow =encodeURIComponent(origin);///netbar/api/wechat/v1/get_open_id
                let scope = 'snsapi_userinfo';    //snsapi_userinfo   //静默授权 用户无感知
                let appid =  process.env.VUE_APP_APPID;
                let state = '1';
                let url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${urlNow}&response_type=code&scope=${scope}&state=${state}#wechat_redirect`

                window.location.href=url;

                // alert('第一次进入'+url);

            }
            else if (!localStorage.getItem("code"))
            {
                // alert('第二次进入且路径存在code');
                localStorage.setItem("code",this.getUrlParme("code"));
                let paramCode = {
                    code:this.getUrlParme("code"),
                    appName:process.env.VUE_APP_NAME,
                    ouid:process.env.VUE_APP_WECHAT_OUID
                }
                // alert(this.getUrlParme("code"));
                service.getUeserOpenIdNew(qs.stringify(paramCode)).then(res=>{
                    // alert(res.data);
                    if(res.code==200){

                        localStorage.setItem('openId',res.data.openId);
                        localStorage.setItem('accessToken',res.data.accessToken);

                        let param={
                            openId:res.data.openId,
                            accessToken:res.data.accessToken
                        }
                        service.getWxUser(qs.stringify(param)).then(res=>{

                            if(res.code==200){
                                localStorage.setItem("userImage",res.data.headimgurl)
                                this.$router.replace('/login');

                            }else{
                                Dialog.alert({
                                    title: '请求失败：'+res.msg,
                                })
                            }

                        }).catch(res=>{
                            console.log(res)
                            // alert(res);
                        })



                    }else{
                        Dialog.alert({
                            title: '错误提示',
                            message: res.msg,
                        }).then(() => {
                            // on close
                        });
                    }

                }).catch(res=>{
                    alert(res);
                })

            }
            else if (localStorage.getItem("openId"))
            {
                if(localStorage.getItem('token'))
                {

                    let param = {
                        openId:localStorage.getItem("openId"),
                        appName:process.env.VUE_APP_NAME,
                        ouid:process.env.VUE_APP_WECHAT_OUID
                    }
                    service.getUeserOpenId(qs.stringify(param)).then(res=>{
                        if(res.code==200){
                            localStorage.setItem('userId',res.data.merchantInfo.user_id);
                            localStorage.setItem('token',res.data.token);
                            this.$store.dispatch("setToken",res.data.token);
                            this.$store.dispatch("setPersonName",res.data.merchantInfo.person_name);
                            this.$store.dispatch("setPhoneNumber",res.data.merchantInfo.phone_number);
                            this.$store.dispatch("setPersonId",res.data.merchantInfo.person_id);
                            this.$router.replace("/Home/Search");

                        }else{
                            this.$router.replace('/login');
                        }

                    }).catch(res=>{
                        alert(res);
                    })
                }
            }
        },
        methods:{

            login() {
                this.show= true;

                if(this.username==""){
                    Dialog.alert({
                        title: '错误提示',
                        message: "手机号码不能为空",
                    }).then(() => {
                        this.show= false;
                    });
                    return ;
                }

                if(!this.value){
                    Dialog.alert({
                        title: '错误提示',
                        message: "请拖动滑块完成验证",
                    }).then(() => {
                        this.show= false;
                    });
                    return ;
                }

                // if(!this.checked){
                //     Dialog.alert({
                //         title: '错误提示',
                //         message: "请同意用户协议",
                //     }).then(() => {
                //         this.show= false;
                //     });
                //     return ;
                // }

                let param = {
                    appid:this.appid,
                    username:this.username,
                    password:this.password,
                    smsCode:this.smsCode,
                    system:50,
                    userImage:localStorage.getItem("userImage"),
                    openId:localStorage.getItem("openId"),
                    ouid:process.env.VUE_APP_WECHAT_OUID
                    // openId:"oSIwMuOXYkrcXBAOK2DA5NGSLmaM"
                }

                service.getRoute(param).then(routeRes=>{
                    if(routeRes.code==200){
                        localStorage.setItem("cang.base.url",routeRes.data.urlHost);
                        localStorage.setItem("appid",this.appid);
                        service.login(param).then(res=>{
                            if(res.code==200){
                                console.log(res.data)
                                let userinfo=res.data.merchantInfo
                                this.$store.dispatch("setToken",res.data.token);
                                this.$store.dispatch("setOrgunit",JSON.stringify(res.data.orgName));
                                this.$store.dispatch("setPersonName",userinfo.person_name);
                                this.$store.dispatch("setPhoneNumber",userinfo.phone_number);
                                this.$store.dispatch("setDeliveryIdnumber","341226199310085770");
                                // this.$store.dispatch("setDeliveryId",res.data.deliveryId);
                                this.$store.dispatch("setUserId",userinfo.user_id);
                                this.$store.dispatch("setPersonId",1);

                                if(res.data.orgName.length>0){
                                    localStorage.setItem("ouid",res.data.orgName[0].ouid)
                                    localStorage.setItem("ouName",res.data.orgName[0].ouName)
                                    localStorage.setItem("systemId",res.data.orgName[0].systemId)
                                    localStorage.setItem("customerId",res.data.orgName[0].customerId)
                                    localStorage.setItem("customerName",res.data.orgName[0].customerName)
                                }

                                this.$router.replace("/Home/Search")
                            }else{
                                Dialog.alert({
                                    title: '错误提示',
                                    message: res.msg,
                                }).then(() => {
                                    // on close
                                });
                            }
                            this.show= false;
                        }).catch(res=>{
                            console.log(res.message);
                            Dialog.alert({
                                title: '错误提示',
                                message: res.message,
                            }).then(() => {
                                // on close
                            });
                            this.show= false;
                        })
                    }

                })



            },
            getQueryString(name){
                let reg =new RegExp('(^|&)' + name + '=([^&]*)(&|$)','i');
                let r = window.location.search.substr(1).match(reg);
                if(r!=null)
                {
                    return unescape(r[2]);
                }
                return null;
            },
            getUrlParme(parameName){
                let parames=window.location.search
                if(parames.indexOf(parameName) > -1 )
                {
                    let parameValue = parames.substring(parames.indexOf(parameName),parames.length)
                    if(parameValue.indexOf('&') > -1)
                    {
                        parameValue = parameValue.substring(0,parameValue.indexOf('&'))
                        parameValue = parameValue.replace(parameName + '=','')
                        return parameValue
                    }
                    return ''

                }
            },
            register(){
                this.$router.replace("/RegisterDelivery")
            },
            sendMsg(){

                if (this.username == '') {
                    Toast('用户名不能为空');
                    return false
                }
                if (this.password == '') {
                    Toast('密码不能为空');
                    return false
                }
                let param={
                    appid:this.appid,
                    username:this.username,
                    password:this.password,
                    systemId:50,
                    userType:20
                }

                service.getRoute(param).then(routeRes=>{
                    if(routeRes.code==200){
                        localStorage.setItem("cang.base.url",routeRes.data.urlHost);
                        localStorage.setItem("appid",this.appid);
                        service.getCustomerLoginCode(param).then(res=>{
                            if(res.code==200){
                                Toast('发送成功');
                                this.smstime=60;
                                this.buttonStatus=true;
                                this.timer = setInterval(() => {          //
                                    this.smstime--;
                                    this.buttonTxt=this.smstime+"秒后重试";
                                    if(this.smstime <= 0) {
                                        this.smstime = 0
                                        this.buttonStatus=false;
                                        this.buttonTxt="重新获取"
                                        clearInterval(this.timer);
                                    }
                                    // if(this.smstime==10){
                                    //     Toast('验证码:1');
                                    // }
                                }, 1000)
                            }else{
                                Toast(res.msg);
                            }

                        }).catch(res=>{
                            alert(res);
                        })
                    }

                })



            },
            showAgreement(){
                this.$router.replace("/Agreement")
            },
            clearSession(){
                this.clearSessionTime++
                if(this.clearSessionTime==3){
                    let str = "code:"+window.localStorage.getItem('code');
                    str+="|"+"token:"+window.localStorage.getItem('token');
                    str+="|"+"personName:"+window.localStorage.getItem('personName');
                    str+="|"+"phoneNumber:"+window.localStorage.getItem('phoneNumber');
                    str+="|"+"deliveryIdnumber:"+window.localStorage.getItem('deliveryIdnumber');
                    str+="|"+"deliveryId:"+window.localStorage.getItem('deliveryId');
                    str+="|"+"userId:"+window.localStorage.getItem('userId');
                    str+="|"+"openId:"+window.localStorage.getItem('openId');
                    str+="|"+"url:"+window.localStorage.getItem('url');
                    alert(str);

                    Dialog.confirm({
                        title: '提示消息',
                        message: '确定要清除缓存吗？',
                        confirmButtonColor:"#6685a4"
                    })
                        .then(() => {
                            window.localStorage.removeItem('code');
                            window.localStorage.removeItem('token');
                            window.localStorage.removeItem('personName');
                            window.localStorage.removeItem('phoneNumber');
                            window.localStorage.removeItem('deliveryIdnumber');
                            window.localStorage.removeItem('deliveryId');
                            window.localStorage.removeItem('userId');
                            window.localStorage.removeItem('openId');
                            Toast('缓存清理完毕');
                            this.clearSessionTime=0;
                        })
                        .catch(() => {
                            // on cancel
                            this.clearSessionTime=0;
                        });

                }
            }
        }
    }
</script>

<style scoped lang="scss">

    .block{
        width: 100%;
        height:100vh;
        background-image: url('../assets/image/top.jpg');
        background-repeat: no-repeat;
        background-size: 100% 100%;
    }
    .loginlogo{
        padding-top:100px;
    }
    .loginbar{
        width:90%;
        margin:50px auto 0px auto;
    }
    .wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
    }

    .userbiz{
        font-size: 16px;
        margin-top: 10px;
        text-align: center;
        color: #6685a4;
    }

    .agreewarp{
        font-size: 14px;
        text-align: center;
        width: 200px;
        margin: 50px auto;
        a{
            color: #6685a4;
        }

        left: 0;
        right: 0;
        height: 30px;

    }



    .footer{
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        height: 60px;
        font-size: 12px;
    }

</style>
